module.exports = __webpack_public_path__ + "img/address-mobile.7072e6eb.png";